module.exports = __webpack_public_path__ + "img/user-green.a81fce4e.png";